"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChevronIcon = function ChevronIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    version: "1.1",
    xmlns: "https://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink"
  }, /*#__PURE__*/_react.default.createElement("title", null, "Icon/Chevron/Right"), /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "0",
    y: "0",
    width: "12",
    height: "12"
  }), /*#__PURE__*/_react.default.createElement("polyline", {
    stroke: "#212121",
    strokeLinecap: "round",
    transform: "translate(6.000000, 6.000000) rotate(-90.000000) translate(-6.000000, -6.000000) ",
    points: "2 4 6 8 10 4"
  })));
};

var _default = ChevronIcon;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pY29ucy9DaGV2cm9uSWNvbi50c3giXSwibmFtZXMiOlsiQ2hldnJvbkljb24iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVBLElBQU1BLFdBQWUsR0FBRyxTQUFsQkEsV0FBa0I7QUFBQSxzQkFDdEI7QUFDRSxJQUFBLEtBQUssRUFBQyxNQURSO0FBRUUsSUFBQSxNQUFNLEVBQUMsTUFGVDtBQUdFLElBQUEsT0FBTyxFQUFDLFdBSFY7QUFJRSxJQUFBLE9BQU8sRUFBQyxLQUpWO0FBS0UsSUFBQSxLQUFLLEVBQUMsNkJBTFI7QUFNRSxJQUFBLFVBQVUsRUFBQztBQU5iLGtCQVFFLGlFQVJGLGVBU0U7QUFBRyxJQUFBLE1BQU0sRUFBQyxNQUFWO0FBQWlCLElBQUEsV0FBVyxFQUFDLEdBQTdCO0FBQWlDLElBQUEsSUFBSSxFQUFDLE1BQXRDO0FBQTZDLElBQUEsUUFBUSxFQUFDO0FBQXRELGtCQUNFO0FBQU0sSUFBQSxDQUFDLEVBQUMsR0FBUjtBQUFZLElBQUEsQ0FBQyxFQUFDLEdBQWQ7QUFBa0IsSUFBQSxLQUFLLEVBQUMsSUFBeEI7QUFBNkIsSUFBQSxNQUFNLEVBQUM7QUFBcEMsSUFERixlQUVFO0FBQ0UsSUFBQSxNQUFNLEVBQUMsU0FEVDtBQUVFLElBQUEsYUFBYSxFQUFDLE9BRmhCO0FBR0UsSUFBQSxTQUFTLEVBQUMsbUZBSFo7QUFJRSxJQUFBLE1BQU0sRUFBQztBQUpULElBRkYsQ0FURixDQURzQjtBQUFBLENBQXhCOztlQXNCZUEsVyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBGQyB9IGZyb20gJ3JlYWN0JztcblxuY29uc3QgQ2hldnJvbkljb246IEZDID0gKCkgPT4gKFxuICA8c3ZnXG4gICAgd2lkdGg9XCIxMnB4XCJcbiAgICBoZWlnaHQ9XCIxMnB4XCJcbiAgICB2aWV3Qm94PVwiMCAwIDEyIDEyXCJcbiAgICB2ZXJzaW9uPVwiMS4xXCJcbiAgICB4bWxucz1cImh0dHBzOi8vd3d3LnczLm9yZy8yMDAwL3N2Z1wiXG4gICAgeG1sbnNYbGluaz1cImh0dHBzOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rXCJcbiAgPlxuICAgIDx0aXRsZT5JY29uL0NoZXZyb24vUmlnaHQ8L3RpdGxlPlxuICAgIDxnIHN0cm9rZT1cIm5vbmVcIiBzdHJva2VXaWR0aD1cIjFcIiBmaWxsPVwibm9uZVwiIGZpbGxSdWxlPVwiZXZlbm9kZFwiPlxuICAgICAgPHJlY3QgeD1cIjBcIiB5PVwiMFwiIHdpZHRoPVwiMTJcIiBoZWlnaHQ9XCIxMlwiPjwvcmVjdD5cbiAgICAgIDxwb2x5bGluZVxuICAgICAgICBzdHJva2U9XCIjMjEyMTIxXCJcbiAgICAgICAgc3Ryb2tlTGluZWNhcD1cInJvdW5kXCJcbiAgICAgICAgdHJhbnNmb3JtPVwidHJhbnNsYXRlKDYuMDAwMDAwLCA2LjAwMDAwMCkgcm90YXRlKC05MC4wMDAwMDApIHRyYW5zbGF0ZSgtNi4wMDAwMDAsIC02LjAwMDAwMCkgXCJcbiAgICAgICAgcG9pbnRzPVwiMiA0IDYgOCAxMCA0XCJcbiAgICAgID48L3BvbHlsaW5lPlxuICAgIDwvZz5cbiAgPC9zdmc+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBDaGV2cm9uSWNvbjtcbiJdfQ==